import { render, staticRenderFns } from "./AddEditLeaveType.vue?vue&type=template&id=99d5d0b6"
import script from "./AddEditLeaveType.vue?vue&type=script&lang=js"
export * from "./AddEditLeaveType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports